import React from "react";
import { useTranslation } from "react-i18next";

import Header from "../../components/header";
import SeoHead from "../../components/seoHead";
import { LocalizedLink, useBarePathname } from "../../i18n/LocaleRouting";

export default function NotFoundPage() {
  const { t } = useTranslation();
  const barePath = useBarePathname();

  return (
    <>
      <SeoHead
        title={t("seo.notFound.title")}
        description={t("seo.notFound.description")}
        path={barePath}
        noindex
      />
      <Header />
      <div className="min-h-screen bg-slate-900 text-slate-300 flex flex-col items-center justify-center gap-4 px-6">
        <h1 className="text-3xl font-bold text-white">{t("common.notFound")}</h1>
        <LocalizedLink
          to="/"
          className="text-red-300 hover:text-red-200 underline"
        >
          {t("common.backHome")}
        </LocalizedLink>
      </div>
    </>
  );
}
